import React from 'react';
import PropTypes from 'prop-types';

const Switch = ({ theme, fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.22503 4.77003L5.60253 2.38503C5.65809 2.31365 5.73522 2.26212 5.82243 2.2381C5.90964 2.21408 6.00228 2.21886 6.08655 2.25173C6.17083 2.2846 6.24224 2.34379 6.29016 2.42051C6.33809 2.49723 6.35996 2.58738 6.35253 2.67753V4.17753H14.04C14.2662 4.17949 14.4825 4.2702 14.6424 4.43012C14.8024 4.59004 14.8931 4.80637 14.895 5.03253V9.32253C14.895 9.548 14.806 9.76434 14.6473 9.92447C14.4885 10.0846 14.273 10.1756 14.0475 10.1775C13.9346 10.1785 13.8226 10.1571 13.718 10.1146C13.6134 10.0721 13.5183 10.0093 13.4381 9.92977C13.3579 9.85028 13.2943 9.75569 13.2508 9.65146C13.2074 9.54724 13.185 9.43544 13.185 9.32253V5.91753H6.33753V7.41753C6.34688 7.50835 6.32639 7.59974 6.27914 7.67787C6.2319 7.756 6.16049 7.81661 6.07572 7.85051C5.99095 7.88442 5.89744 7.88978 5.80935 7.86579C5.72126 7.84179 5.64339 7.78974 5.58753 7.71753L3.23253 5.36253C3.19235 5.32458 3.1602 5.27894 3.138 5.22832C3.1158 5.1777 3.104 5.12313 3.1033 5.06787C3.1026 5.0126 3.11302 4.95775 3.13393 4.90659C3.15484 4.85543 3.18582 4.80899 3.22503 4.77003Z"
      fill={fill || theme.COLORS.primary}
    />
    <path
      d="M14.775 13.23L12.3975 15.615C12.3419 15.6864 12.2648 15.7379 12.1776 15.7619C12.0904 15.786 11.9977 15.7812 11.9135 15.7483C11.8292 15.7154 11.7578 15.6562 11.7098 15.5795C11.6619 15.5028 11.64 15.4127 11.6475 15.3225V13.8225H3.95998C3.73383 13.8206 3.51749 13.7298 3.35757 13.5699C3.19765 13.41 3.10694 13.1937 3.10498 12.9675V8.64751C3.10497 8.42205 3.19402 8.2057 3.35275 8.04557C3.51147 7.88544 3.72702 7.79449 3.95248 7.79251C4.06539 7.79152 4.17738 7.81291 4.28198 7.85543C4.38658 7.89795 4.48172 7.96078 4.56191 8.04027C4.6421 8.11976 4.70575 8.21435 4.74919 8.31858C4.79262 8.4228 4.81498 8.5346 4.81498 8.64751V12.0825H11.6625V10.5825C11.6531 10.4917 11.6736 10.4003 11.7209 10.3222C11.7681 10.244 11.8395 10.1834 11.9243 10.1495C12.0091 10.1156 12.1026 10.1103 12.1907 10.1343C12.2787 10.1583 12.3566 10.2103 12.4125 10.2825L14.79 12.6675C14.8591 12.7458 14.8961 12.8473 14.8933 12.9517C14.8905 13.0561 14.8482 13.1556 14.775 13.23Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

Switch.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Switch;
